/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  searchResult: {},
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  errors: [],
  fromDateValue: '',
  isAllRebateProgram: false,
  riderNumber: '',
  displayObj: {
    rebateProgram: '',
    fromDateValue: '',
    searchResult: {},
    rebateProgramList: [],
    isAllRebateProgram: false,
    riderNumber: '',
    rebateProgrameName: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_RIDER:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.GET_RIDER_REPORT:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };
    case ActionTypes.SET_SELECTED_INPUT_RIDER:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_RIDER_REPORT:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.SET_PAGINATION_INDEX_RIDER:
      return {
        ...state,

        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.REFRESH_RIDER_REPORT_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
